const ShimmerCard = () => {
    return (
        <div className="shimmer_container">
            <div className="shimmer_card"></div>
            <div className="shimmer_card"></div>
            <div className="shimmer_card"></div>
            <div className="shimmer_card"></div>
            <div className="shimmer_card"></div>
            <div className="shimmer_card"></div>
            <div className="shimmer_card"></div>
            <div className="shimmer_card"></div>
            <div className="shimmer_card"></div>
            <div className="shimmer_card"></div>
        </div>
    );
};
export default ShimmerCard;